<script>
	import { External, M } from '../external';
	import { onMount } from 'svelte';
	import ListPicker from '../Popups/ListPicker.svelte';
	import DetailsSection from './Profile/DetailsSection.svelte';
	import MembershipSection from './Profile/MembershipSection.svelte';
	import Shortcuts from './Profile/Shortcuts.svelte';
	import FormSubmits from './Tabs/FromSubmits.svelte';
	import OrdersTable from '../Store/OrdersTable.svelte';
	import ContactHistory from '../ContactHistory/Index.svelte';
	import Notes from './Tabs/Notes.svelte';
	import Subscriptions from './Tabs/Subscriptions.svelte';
	import Appointments from './Tabs/Appointments.svelte';
	import Activities from './Tabs/Activities/Activities.svelte';
	import Tags from './Profile/Tags.svelte';
	import ContactAvatar from './Profile/ContactAvatar.svelte';
	import MemberProfile from '../LMS/member/MemberProfile.svelte';
  import { ignore } from '../Common/tools';
	import CommentAdminService from '../Common/CommentAdminService';

	export let id = 0,
    inPopup = false,
    defaultTab = 'activities',
    onComponentReady = ignore;

  let container;

	const contact = {
		data: null,
		getNameInitials: () => {
			if (!contact.data) {
				return '';
			}

			const userData = External.Tools.getColorAndInitialsFromNameAndEmail(contact.data.name, contact.data.email);
			return userData.initials;
		},
		getUserColor: () => {
			if (!contact.data) {
				return '';
			}

			const userData = External.Tools.getColorAndInitialsFromNameAndEmail(contact.data.name, contact.data.email);
			return userData.color;
		},
		fetch: () => {
			return new Promise((resolve) => {
				External.Tools.makeWebsiteRequest({
					action: 'getContactDetails',
					data: {
						id: id
					},
					onOk: function (result) {
						contact.data = result.data;
						contact.data.firstSeenValue = External.Tools.dateToString(new Date(contact.data.createdOn), true);
						resolve();
					}
				});
			})
		},
		setContactProperty: (type, propertyId, value) => {
			const data = {
				id: id,
				type: type,
				value: value
			};
			if (propertyId) {
				data.property = propertyId;
			}
			External.Tools.makeWebsiteRequest({
				action: 'setContactProperty',
				data: data
			});
		},
		updateContactProperty: (propertyId, value) => {
			const type = External.CRM_FILTER_TYPE.PROPERTY;
			contact.setContactProperty(type, propertyId, value);
		},
		changeSubscriptionStatus: () => {
			const {subscribed} = contact.data;
			External.Tools.prompt(subscribed ? M.CONTACT_UNSUBSCRIBE : M.SUBSCRIBE, M.DEL_CONFIRM, () => {
				External.Tools.makeWebsiteRequest({
					action: 'changeSubscribeStatus',
					data: {
						id: id,
						subscribed: !subscribed
					},
					onOk: function (result) {
						const data = result.data;
						contact.data.subscribed = data.subscribed;
						if (data.subscribed && !data.lists) {
							let listPickerComponent;
							const buttons = [
								External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup) {
									let list = listPickerComponent.get().list;
									if (list === '') {
										External.Tools.showError(M.SELECT_LIST_FIRST);
										return;
									}
									External.Tools.makeWebsiteRequest({
										action: 'addContactIdToList',
										data: {
											listId: list,
											contactId: id
										},
										onOk: function () {
											External.CPanel.goToUrl(External.CPanel.currentPage, true);
											popup.close();
										}
									});
								}),
								External.Button.MIDDLE_CLOSE
							];

							External.Tools.makeWebsiteRequest({
								action: 'getMarketingLists',
								onOk: function (response) {
									if (!response.data) return;

									External.Tools.showWindow({
										isModal: false,
										title: M.CHOOSE_SUBSCRIBER_LIST_TITLE,
										width: 450,
										buttons: buttons,
										markup: '<div class="popup-widget-wrapper"></div>',
										action: {
											onShow: function (popup, context) {
												listPickerComponent = new ListPicker({
													target: context.find('.popup-widget-wrapper')[0],
													props: {
														data: {},
														showNewListButton: true
													}
												});
											},
											onHide: function () {
												if (listPickerComponent && listPickerComponent.$destroy) {
													listPickerComponent.$destroy();
												}
												listPickerComponent = null;
											}
										}
									});
								}
							});
						}
					}
				});
			});
		},
		deleteContact: () => {
			var selection = {
				all: false,
				selected: [id],
				unselected: []
			};

			External.Tools.makeWebsiteRequest({
				action: 'deleteContacts',
				method: 'post',
				data: {
					filter: JSON.stringify([]),
					selection: JSON.stringify(selection)
				},
				onOk: function () {
					External.CPanel.goToUrl('/me/crm');
				}
			});
		},
		resetMemberPassword: () => {
			External.Tools.makeWebsiteRequest({
				action: 'resetMemberPassword',
				data: {
					id: contact.data.member.id
				},
				onOk: function () {
					External.Tools.showAutohideMessage(2000, M.PASSWORD_RESET_SENT);
				}
			});
		},
		approveDenyMember: (approve) => {
			External.Tools.makeWebsiteRequest({
				action: 'approveMember',
				data: {
					approve: approve,
					id: id
				},
				onOk: function () {
					if (approve) {
						External.CPanel.goToUrl(External.CPanel.currentPage, true);
					} else {
						External.CPanel.goToUrl('/me/crm');
					}
				}
			});
		},
		makeMember: (groupIds) => {
			External.Tools.makeWebsiteRequest({
				action: 'createMember',
				data: {
					name: contact.data.name,
					email: contact.data.email,
					groups: groupIds.join(',')
				},
				onOk: function () {
					External.CPanel.goToUrl(External.CPanel.currentPage, true);
				}
			});
		},
		isMember: () => {
			return !!contact.data.member;
		},
		isAdmin: () => {
			return communityRoles?.default === 0;
    },isModerator: () => {
			return communityRoles?.default === 1;
		},
		isMuted: () => {
			return communityRoles?.default >= 1_000_000;
		},
		saveMemberGroups: (newGroupIds) => {
			External.Tools.makeWebsiteRequest({
				action: 'saveMemberGroups',
				data: {
					id: contact.data.member.id,
					groups: newGroupIds.join(',')
				},
				onOk: function () {
					contact.data.member.groupIds = newGroupIds;
				}
			});
		},
		changeCommunityManagerStatus: async (type) => {
			let response;
			switch (type) {
				case 'moderator':
					response = await CommentAdminService.makeModerator(contact.data.member?.id, 'default');
					break;
				case 'admin':
					response = await CommentAdminService.makeAdmin(contact.data.member?.id, 'default');
					break;
				case 'member':
					response = await CommentAdminService.makeOrdinaryMember(contact.data.member?.id, 'default');
					break;
			}

			if(response.ok) {
				External.CPanel.goToUrl(External.CPanel.currentPage, true);
			}
		},
		muteMember: async () => {
			const response = await CommentAdminService.muteMember(contact.data.member?.id, 'default');
			if(response.ok) {
				External.CPanel.goToUrl(External.CPanel.currentPage, true);
			}
		},
		unmuteMember: async () => {
			const response = await CommentAdminService.unmuteMember(contact.data.member?.id, 'default');
			if(response.ok) {
				External.CPanel.goToUrl(External.CPanel.currentPage, true);
			}
		}
	};

	const profileSection = {
		currentTab: 'details',
		changeTab: (tab) => {
			profileSection.currentTab = tab;
		}
	};

	const tabsSection = {
		currentTab: defaultTab || 'activities',
		changeTab: (tab) => {
			tabsSection.currentTab = tab;
		},
		tabs: {
			activities: {
				title: M.ACTIVITY,
				isVisible: () => {
					return true;
				}
			},
			lms: {
				title: M.COMMUNITY,
				isVisible: () => {
					return !!contact.data.member?.id && External.Website.hasPermission(External.Permission.COMMUNITY_MEMBERS);
				}
			},
			notes: {
				title: M.NOTES,
				isVisible: () => {
					return true;
				}
			},
			forms: {
				title: M.FORMS,
				isVisible: () => {
					return External.Website.hasPermission(External.Permission.MESSAGES);
				}
			},
			orders: {
				title: M.ORDERS,
				isVisible: () => {
					return External.Website.hasPermission(External.Permission.STORE);
				}
			},
			subscriptions: {
				title: M.SUBSCRIPTIONS,
				isVisible: () => {
					return External.Website.hasPermission(External.Permission.STORE);
				}
			},
			marketing: {
				title: M.MARKETING_DETAILS,
				isVisible: () => {
					return External.Website.isMarketingEnabled();
				}
			},
			appointments: {
				title: M.APPOINTMENTS,
				isVisible: () => true
			}
			// affiliate: {
			//   title: M.AFFILIATE_DETAILS || 'M.AFFILIATE_DETAILS',
			//   component: 'Affiliate'
			// }
		}
	};

  const showFullProfile = () => {
    External.Tools.closeAllPopups(() => {
      External.CPanel.goToUrl("/me/crm/contact/" + id, true);
    });
  }

	let communityRoles = null;
	const fetchCommunityRoles = () => {
		return new Promise(async (resolve) => {
			if(!contact.data.member?.id) {
				// not a member
				resolve();
			}
			const result = await CommentAdminService.getMemberDetails(contact.data.member?.id);
			communityRoles = result?.roles;
			resolve();
		})
	}

	onMount(async () => {
		if (!External.Website.hasPermission(External.Permission.MEMBERS)) {
			External.CPanel.goToUrl('/me/dashboard');
			return;
		}

		await contact.fetch();
		await fetchCommunityRoles();
		if (onComponentReady) {
			onComponentReady();
		}

		let tab = External.WebPlatform.getUrlQueryParameter(window.location.href, 'tab');
		if (tab) {
			tabsSection.changeTab(tab);
		}
	});
</script>

<div class="full-size flex flex-row-col-responsive">
	{#if contact.data}

		<div bind:this={container} class="account-settings overflow store-products flex-1 horizontal-flex-table with-top-background">

			<div class="content-wrapper crm-profile-wrapper full-size flex flex-row-col-responsive" class:side-contact-profile={inPopup}>

				<div class="crm-contact-sidebar white-bg">
          {#if inPopup}
					  <a on:click={showFullProfile} class="middle-button light-gray-bg2 circle-effect full-profile-btn none-soft">{M.FULL_PROFILE}</a>
          {/if}
					<div class="col20 contact-sidebar flex flex-col t-center align-center relative">
						<!-- Arrow to all contacts -->
						<a
							class="back-with-arrow absolute"
							data-action="back"
							rel="action"
							on:click={() => {
	            window.history.back();
	          }}>
							<svg
								class="rounded-effect"
								height="48"
								viewBox="0 -960 960 960"
								width="48"
								xmlns="http://www.w3.org/2000/svg">
								<path d="M359-242 120-481l239-239 43 43-166 166h604v60H236l166 166-43 43Z"></path>
							</svg>
						</a>
						<!-- Arrow to all contacts END -->
						<!-- Profile Info -->
						<ContactAvatar wrapperClasses="contact-image mb-10 relative" contact={contact.data}>
							<svelte:fragment slot="subscribed-fragment">
								{#key contact.data.subscribed}
									<div class="subscribe-badge-icon circle-effect button-tooltip"
											 data-tooltip={contact.data.subscribed ? M.UNSUBSCRIBE : M.SUBSCRIBE}
											 class:pending={!contact.data.subscribed}
											 class:green-bg={contact.data.subscribed}
											 on:click={contact.changeSubscriptionStatus}>
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
											<path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/>
										</svg>
									</div>
								{/key}
							</svelte:fragment>
						</ContactAvatar>
						<h4 class="col20"><b>{contact.data.name}</b></h4>
						<span>{contact.data.email}</span>
						{#if communityRoles?.default === 1}
							<div class="contact-rank circle-effect">{M.COMMUNITY_MODERATOR}</div>
						{/if}
            {#if communityRoles?.default === 0}
              <div class="contact-rank circle-effect">{M.ADMIN}</div>
            {/if}
						<!-- Profile Info End -->
						<Shortcuts
							{contact}
							changeTabToNotes={() => {
	            tabsSection.changeTab('notes');
	          }}/>
						{#if contact.data.member}
							<div class="mt-10 flex align-center">
								<span class="activity-dot green-bg flex-none"></span>
								<span class="activity-text">
	  			{M.LAST_ACTIVITY}:
									{contact.data.member?.lastLogin ? External.Tools.dateToString(new Date(contact.data.member.lastLogin)) : '-'}
	  			</span>
							</div>
						{/if}
						<ul class="profile-navigation profile-navigation-center f-left col20 mt-15 mb-15">
							<li>
								<a
									class:active={profileSection.currentTab === 'details'}
									on:click={() => {
	                profileSection.changeTab('details');
	              }}
									data-action="showTab"
									data-tab="details"
									rel="action">{M.DETAILS}</a>
							</li>
							<li>
								<a
									class:active={profileSection.currentTab === 'membership'}
									on:click={() => {
	                profileSection.changeTab('membership');
	              }}
									data-action="showTab"
									data-tab="membership"
									rel="action">{M.MEMBERSHIP}</a>
							</li>
						</ul>
						{#if profileSection.currentTab === 'details'}
							<DetailsSection {contact}/>
						{/if}
						{#if profileSection.currentTab === 'membership'}
							<MembershipSection {contact}/>
						{/if}
					</div>
					<div class="col20 f-left contact-sidebar contact-tags-wrapper mt-10">
						<Tags {contact}/>
					</div>
				</div>

				<div class="padded-crm-wrapper flex" style="padding-top: 0px; padding-bottom: 40px;">

					<div class="col20 crm-profile-content-wrapper">
						<ul class="profile-navigation t-center profile-navigation-centered">
							{#each Object.entries(tabsSection.tabs) as [key, tab]}
								{#if tab.isVisible()}
									<li>
										<a
											class={key === tabsSection.currentTab ? 'active' : ''}
											data-tab={key}
											on:click={() => {
                      tabsSection.changeTab(key);
                    }}>
											{tab.title}
										</a>
									</li>
								{/if}
							{/each}
						</ul>
						<div class="col20 f-left mt-15">
							{#if tabsSection.currentTab === 'forms'}
								<FormSubmits {contact}/>
							{:else if tabsSection.currentTab === 'orders'}
								<OrdersTable contact={id} options={{ openOrdersIn: 'popup', name: false, selection: false }}/>
							{:else if tabsSection.currentTab === 'marketing'}
								<ContactHistory contact={contact.data}/>
							{:else if tabsSection.currentTab === 'notes'}
								<Notes {contact}/>
							{:else if tabsSection.currentTab === 'subscriptions'}
								<Subscriptions contact={contact.data}/>
							{:else if tabsSection.currentTab === 'appointments'}
								<Appointments {contact}/>
							{:else if tabsSection.currentTab === 'activities'}
								<Activities {contact} {container}/>
							{:else if tabsSection.currentTab === 'lms'}
								<MemberProfile memberId={contact.data?.member?.id} contactId={contact.data?.id} groupIds={contact.data?.member?.groupIds} />
							{/if}

							<div class="affiliateDetails none-soft">
								<div class="affiliate-details-wrapper col20 f-left"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	{/if}
</div>
